
import CreateRole from 'features/Admin/Roles/RoleManager/pages/CreateRole';
// import CreateUser from "pages/Admin/CreateUser";
import EditRole from 'features/Admin/Roles/RoleManager/pages/EditRole';
// import EditUser from "pages/Admin/EditUser";
import { default as RoleManager } from 'pages/Admin/RoleManager';
import EditUser from "pages/EditUser/EditUser.index";
import { default as AIAnalytics, default as AIAnalytics } from 'pages/Overwatch/AIAnalytics';
import { ServiceManager } from 'pages/Overwatch/ServicesManager';
// import Connections from "pages/System/Connections";
import Organization from 'pages/Settings/Organization';
import FemaCredentials from 'pages/Settings/FemaCredentials';
import GlobalActions from 'pages/System/GlobalActions/GlobalActions';
import Help from 'pages/System/Help';
import Integrations from 'pages/System/Integrations/Integrations';
import { LicenseInformation } from 'pages/System/LicenseInformation';
import ManageSocials from 'pages/System/ManageSocials';
import UserMenu from 'pages/UserMenu/UserMenu';
import Alerts from 'pages/Weather/Alerts';
import Charts from 'pages/Weather/Charts';
import WeatherForecast from 'pages/Weather/Forecast';
import Maps from 'pages/Weather/Maps';
import MarineForecast from 'pages/Weather/MarineForecast/MarineForecast';
import SpecialReports from 'pages/Weather/SpecialReports';
import StormCenter from 'pages/Weather/StormCenter';
//imported images
import IntegrationsRoute from "app/routes/Integrations.route";
import AuditLogsV2 from "features/AuditLogs_v2/AuditLogs_v2.index";
// import AuditLogs from "pages/Admin/AuditLogs"; //replaced by AuditLogsV2
import ViewRole from 'features/Admin/Roles/RoleManager/pages/ViewRole';
import AlarmHistory from 'features/Alarms/features/AlarmHistory/index.web';
import PendingAlarms from 'features/Alarms/features/PendingAlarms/index.web';
import { FEMA_PERMISSIONS } from 'features/Weather/features/WeatherAlerts/features/AlertCreator/components/IpawsAlertFields/config/Ipaws.config';
import { Page404 } from "pages/404";
import UserManager from "pages/Admin/UserManager";
import USGSFullScreen from "pages/System/USGSFullScreen/USGSFullScreen";
import ViewUser from "pages/ViewUser/ViewUser.index";
import CreateAlert from 'pages/Weather/CreateAlert';
import FemaAlerts from 'pages/Weather/FemaAlerts';
import { lazy, Suspense } from 'react';
import { FaListUl } from 'react-icons/fa';
import { FaPeopleGroup } from 'react-icons/fa6';
import { IoCalendar } from 'react-icons/io5';
import { MdAssignmentInd, MdMonitor, MdMonitor, MdTour } from 'react-icons/md';
import { PiVideoFill } from 'react-icons/pi';
import { MdVpnKey } from 'react-icons/md';
import { TbPolygon } from 'react-icons/tb';
import { default as aiAnalyticsIcon, default as aiAnalyticsIcon } from '../assets/nIcons/AI Analytics.png';
import { default as alarmHistoryIcon, default as alarmHistoryIcon } from '../assets/nIcons/Alarm History.png';
import { default as apparatusIcon, default as apparatusIcon } from '../assets/nIcons/Apparatus.png';
import { default as auditLogIcon, default as auditLogIcon } from '../assets/nIcons/Audit Logs.png';
import { default as chartsIcon, default as chartsIcon } from '../assets/nIcons/Charts.png';
import { default as connectedDevicesIcon, default as connectedDevicesIcon } from '../assets/nIcons/Connected Devices.png';
import { default as createAlertIcon, default as createAlertIcon } from '../assets/nIcons/Create Alert.png';
import { default as dispatchChatIcon, default as dispatchChatIcon } from '../assets/nIcons/Dispatcher Chat.png';
import { default as employeesIcon, default as employeesIcon } from '../assets/nIcons/Employees.png';
import { default as forecastIcon, default as forecastIcon } from '../assets/nIcons/Forecast.png';
import {
    default as globalActions2Icon,
    default as globalActions2Icon,
    default as globalActionsIcon,
    default as globalActionsIcon,
} from '../assets/nIcons/Global Actions.png';
import { default as helpIcon, default as helpIcon } from '../assets/nIcons/Help.png';
import { default as connectionsIcon, default as connectionsIcon } from '../assets/nIcons/Integrations.png';
import { default as licenseIcon, default as licenseIcon } from '../assets/nIcons/License Admin.png';
import { default as manageSocialsIcon, default as manageSocialsIcon } from '../assets/nIcons/Manage Socials.png';
import { default as fullMapIcon, default as fullMapIcon, default as mapsIcon, default as mapsIcon } from '../assets/nIcons/Maps.png';
import { default as marineForecastIcon, default as marineForecastIcon } from '../assets/nIcons/Marine Forecast.png';
import { default as organizationIcon, default as organizationIcon } from '../assets/nIcons/Organization.png';
import { default as overwatchIcon, default as overwatchIcon } from '../assets/nIcons/Overwatch.png';
import { default as pendingAlarmsIcon, default as pendingAlarmsIcon } from '../assets/nIcons/Pending Alarms.png';
import { default as publicInfoIcon, default as publicInfoIcon } from '../assets/nIcons/Public Info.png';
import { default as responderIcon, default as responderIcon } from '../assets/nIcons/Responder.png';
import { default as manageRolesIcon, default as manageRolesIcon } from '../assets/nIcons/Roles.png';
import { default as settingsIcon, default as settingsIcon } from '../assets/nIcons/Settings.png';
import { default as specialReportsIcon, default as specialReportsIcon } from '../assets/nIcons/Special Reports.png';
import { default as stormCenterIcon, default as stormCenterIcon } from '../assets/nIcons/Storm Center.png';
import { default as usersIcon, default as usersIcon } from '../assets/nIcons/Users.png';
import {
    default as incidentsIcon,
    default as incidentsIcon,
    default as publicAlertsIcon,
    default as publicAlertsIcon,
    default as weatherAlertsIcon,
    default as weatherAlertsIcon,
} from '../assets/nIcons/Weather Alerts.png';
import { default as weatherIcon, default as weatherIcon } from '../assets/nIcons/Weather.png';

const Activities = lazy(() => import('pages/Responder/Activities'));
const Assignments = lazy(() => import('pages/Responder/Assignments'));
const Personnel = lazy(() => import('pages/Responder/Personnel'));
const Schedules = lazy(() => import('pages/Responder/Schedules'));
const Tours = lazy(() => import('pages/Responder/Tours'));
const Zones = lazy(() => import('pages/Responder/Zones'));

const ResponderRouteLoading = () => (
  <div className="d-flex justify-content-center align-items-center py-5" role="status">
    <div className="spinner-border" aria-hidden="true" />
    <span className="visually-hidden">Loading Responder page...</span>
  </div>
);

const renderResponderPage = (PageComponent) => (
  <Suspense fallback={<ResponderRouteLoading />}>
    <PageComponent />
  </Suspense>
);


export function GetRouteData(perms, widgetRefresh) {
  return [
    {
      name: 'Overwatch',
      icon: () => {
        return <img src={overwatchIcon} style={{ width: 30 }} />;
      }, //no icon = no button
      enabled: true, //enabled is referring to the sidebar button
      opened: false,
      permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['OverwatchEnabled']),
      perm: 'OverwatchEnabled',
      options: [
          {
            name: 'Pending Alarms',
            icon: () => {
              return <img src={pendingAlarmsIcon} style={{ width: 30 }} />;
            },
            enabled: true,
            href: '/overwatch/pendingalarms',
            permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['PendingAlarms']),
            perm: 'PendingAlarms',
            page: <PendingAlarms />, 
          },
          {
            name: 'Alarm History',
            icon: () => {
              return <img src={alarmHistoryIcon} style={{ width: 34 }} />;
            },
            enabled: true,
            href: '/overwatch/alarmhistory',
            permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['AlarmHistory']),
            perm: 'AlarmHistory',
            page: <AlarmHistory />, 
          },
        {
          name: 'AI Analytics',
          icon: () => {
            return <img src={aiAnalyticsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/overwatch/aianalytics',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['AIAnalytics']),
          perm: 'AIAnalytics',
          page: <AIAnalytics />,
        },
        {
          name: 'Service Manager',
          icon: () => {
            return <img src={overwatchIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/overwatch/servicemanager',
          permission: () => {
            let allowed = false;
            allowed = perms.testPermission([8, 13], []); //Level 8 and 13 always allowed
            if (!allowed) {
              //Check if level 12 user has service manager flag
              if (perms.accessLevel === 12) {
                allowed = perms.isServiceManager();
              }
            }
            return allowed;
          },
          perm: 'ServiceManager',
          page: <ServiceManager />,
        },
        {
          name: 'Global Actions',
          icon: () => {
            return <img src={globalActionsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/globalactions',
          permission: () => {
            return (
              perms.testPermission([8, 9, 10, 11, 12, 13], ['GlobalActionsEnabled']) &&
              perms.testPermission([8, 9, 10, 11, 12, 13], ['OverwatchEnabled'])
            );
          },
          perm: 'GlobalActions',
          page: <GlobalActions />,
        },
        {
          name: 'Connected Devices',
          icon: () => {
            return <img src={connectedDevicesIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/devices',
          permission: () => {
            return (
              perms.testPermission([8, 9, 10, 11, 12, 13], ['IntegrationsEnabled']) &&
              perms.testPermission([8, 9, 10, 11, 12, 13], ['OverwatchEnabled'])
            );
          },
          perm: 'ConnectedDevices',
          page: <Integrations />,
        },
      ],
    },
    {
      name: 'Responder',
      icon: () => {
        return <img src={responderIcon} style={{ width: 30 }} />;
      },
      enabled: true,
      opened: false,
      permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['ResponderEnabled']),
      perm: 'ResponderEnabled',
      options: [
        {
          name: 'Zones',
          icon: () => {
            return <TbPolygon size={30} />;
          },
          enabled: true,
          href: '/responder/zones',
          permission: () => perms.testPermission([8, 10, 11, 12, 13], ['ViewEntities']),
          perm: 'ViewEntities',
          page: renderResponderPage(Zones),
        },
        {
          name: 'Tours',
          icon: () => {
            return <MdTour size={30} />;
          },
          enabled: true,
          href: '/responder/tours',
          permission: () => perms.testPermission([8, 10, 11, 12, 13], ['ViewEntities']),
          perm: 'ViewEntities',
          page: renderResponderPage(Tours),
        },
        {
          name: 'Schedules',
          icon: () => {
            return <IoCalendar size={30} />;
          },
          enabled: true,
          href: '/responder/schedules',
          permission: () => perms.testPermission([8, 10, 11, 12, 13], ['ViewScheduleAssignments']),
          perm: 'ViewScheduleAssignments',
          page: renderResponderPage(Schedules),
        },
        {
          name: 'Assignments',
          icon: () => {
            return <MdAssignmentInd size={30} />;
          },
          enabled: true,
          href: '/responder/assignments',
          permission: () => perms.testPermission([8, 10, 11, 12, 13], ['ViewScheduleAssignments']),
          perm: 'ViewScheduleAssignments',
          page: renderResponderPage(Assignments),
        },
        {
          name: "Activities",
          icon: () => {
            return <FaListUl size={30} />;
          },
          enabled: true,
          href: '/responder/activities',
          permission: () => perms.testPermission([8, 10, 11, 12, 13], ['ViewScheduleAssignments']),
          perm: 'ViewScheduleAssignments',
          page: renderResponderPage(Activities),
        },
        {
          name: "Personnel",
          icon: () => {
            return <FaPeopleGroup size={30} />;
          },
          enabled: true,
          href: '/responder/personnel',
          permission: () => perms.testPermission([8, 10, 11, 12, 13], ['ViewPersonnel']),
          perm: 'ViewPersonnel',
          page: renderResponderPage(Personnel),
        },
        // {
        //   name: 'RESPONDER SANDBOX',
        //   icon: () => {
        //     return <img src={fullMapIcon} style={{ width: 30 }} />;
        //   },
        //   enabled: true,
        //   href: '/responder/responder-sandbox',
        //   permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['FullMap']),
        //   perm: 'FullMap',
        //   page: <_ResponderSandbox />,
        // },
      ],
    },
    {
      name: 'Weather',
      icon: () => {
        return <img src={weatherIcon} style={{ width: 30 }} />;
      },
      enabled: true,
      opened: false,
      permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['WeatherEnabled']),
      perm: 'WeatherEnabled',
      options: [
        {
          name: 'Weather Alerts',
          icon: () => {
            return <img src={weatherAlertsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/weather/alerts',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['WeatherAlerts']),
          perm: 'WeatherAlerts',
          page: (
            <Alerts
              filterAlerts={(list) => list.filter((item) => item.provider === 'Custom Weather')}
            />
          ),
        },
        {
          name: 'Forecast',
          icon: () => {
            return <img src={forecastIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/weather/forecast',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['ForecastEnabled']),
          perm: 'ForecastEnabled',
          page: <WeatherForecast widgetRefresh={widgetRefresh} />,
        },
        {
          name: 'Maps',
          icon: () => {
            return <img src={mapsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/weather/maps',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['MapsEnabled']),
          perm: 'MapsEnabled',
          page: <Maps />,
        },
        {
          name: 'Storm Center',
          icon: () => {
            return <img src={stormCenterIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/weather/stormcenter',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['StormCenterEnabled']),
          perm: 'StormCenterEnabled',
          page: <StormCenter />,
        },
        {
          name: 'Marine Forecast',
          icon: () => {
            return <img src={marineForecastIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/weather/marineforecast',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['MarineForecastEnabled']),
          perm: 'MarineForecastEnabled',
          page: <MarineForecast />,
        },
        {
          name: 'Special Reports',
          icon: () => {
            return <img src={specialReportsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/weather/specialreports',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['SpecialReportsEnabled']),
          perm: 'SpecialReportsEnabled',
          page: <SpecialReports />,
        },
        {
          name: 'Charts',
          icon: () => {
            return <img src={chartsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/weather/charts',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['ChartsEnabled']),
          perm: 'ChartsEnabled',
          page: <Charts />,
        },
        {
          name: "USGS Map",
          icon: () => {
            return <img src={mapsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: "/weather/usgs-map",
          permission: () =>
            perms.testPermission([8, 9, 10, 11, 12, 13], ["WeatherEnabled", "ViewUSGSMonitoringStationConnections"]),
          perm: "ViewUSGSMonitoringStationConnections",
          page: <USGSFullScreen />,
        },
      ],
    },
    {
      name: 'Public Info',
      icon: () => {
        return <img src={publicInfoIcon} style={{ width: 30 }} />;
      },
      enabled: true,
      opened: false,
      permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['PublicInfoEnabled']),
      perm: 'PublicInfoEnabled',
      options: [
        {
          name: 'Active Alerts',
          icon: () => {
            return <img src={publicAlertsIcon} style={{ padding: 2, width: 30 }} />;
          },
          enabled: true,
          href: '/publicuser/alerts',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewAlerts']),
          perm: 'ViewAlerts',
          page: <Alerts />,
        },
         {
          name: 'Fema Alerts',
          icon: () => {
            return <img src={publicAlertsIcon} style={{ padding: 2, width: 30 }} />;
          },
          enabled: true,
          href: '/publicuser/femaalerts',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], [FEMA_PERMISSIONS.view]),
          perm: FEMA_PERMISSIONS.view,
          page: <FemaAlerts />,
        },
        {
          name: 'Create Alert',
          icon: () => {
            return <img src={createAlertIcon} style={{ width: 34 }} />;
          },
          enabled: true,
          href: '/publicuser/createalert',
          // RescAlert alert rights OR FEMA alert rights open the creator (FE-01).
          permission: () =>
            perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditAlerts']) ||
            perms.testPermission([8, 9, 10, 11, 12, 13], [FEMA_PERMISSIONS.create]),
          perm: 'Create-EditAlerts',
          page: <CreateAlert />,
        },
      ],
    },
    {
      name: 'System',
      icon: () => {
        return <MdMonitor size={30} />; //<img src={systemIcon} style={{ width: 30 }} />;
      },
      enabled: true,
      opened: false,
      permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['SystemEnabled']),
      perm: 'SystemEnabled',
      options: [
        {
          name: 'Integrations',
          icon: () => {
            return <img src={connectionsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/integrations',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['IntegrationsEnabled']),
          perms: 'IntegrationsEnabled',
          page: <IntegrationsRoute />,
        },
        {
          name: 'Global Actions',
          icon: () => {
            return <img src={globalActions2Icon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/globalactions',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['GlobalActionsEnabled']),
          perm: 'GlobalActionsEnabled',
          page: <GlobalActions />,
        },
        {
          name: 'Manage Socials',
          icon: () => {
            return <img src={manageSocialsIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/managesocials',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['ManageSocialsEnabled']),
          perm: 'ManageSocialsEnabled',
          page: <ManageSocials />,
        },
      ],
    },

    {
      name: 'Settings',
      icon: () => {
        return <img src={settingsIcon} style={{ width: 30 }} />;
      },
      enabled: true,
      opened: false,
      permission: () => perms.testPermission([8, 9, 10, 11, 12, 13]),
      perm: 'SystemEnabled',
      options: [
        {
          name: 'Organization',
          icon: () => {
            return <img src={organizationIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/organization',
          permission: () =>
            perms.testPermission([8, 9, 10, 11, 12, 13], ['ManageOrganizationEnabled']),
          perm: 'ManageOrganizationEnabled',
          page: <Organization />,
        },
        {
          // FE-11: the client FEMA credential page. STRICT key: no super-user bypass.
          name: 'FEMA Credentials',
          icon: () => {
            return <MdVpnKey size={30} />;
          },
          enabled: true,
          href: '/system/femacredentials',
          permission: () =>
            perms.testPermission([8, 9, 10, 11, 12, 13], [FEMA_PERMISSIONS.credentials]),
          perm: FEMA_PERMISSIONS.credentials,
          page: <FemaCredentials />,
        },
        {
          name: 'Roles',
          icon: () => {
            return <img src={manageRolesIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/rolemanager',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['ManageRolesEnabled']),
          perm: 'ManageRolesEnabled',
          page: <RoleManager />,
        },
        {
          name: 'Create Role',
          icon: () => {
            return <img src={manageRolesIcon} style={{ width: 30 }} />;
          },
          enabled: false,
          href: '/system/createrole',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['CreateRole']),
          perm: 'CreateRole',
          page: <CreateRole />,
          hideSidebar: true,
        },
        {
          name: 'Edit Role',
          icon: () => {
            return <img src={manageRolesIcon} style={{ width: 30 }} />;
          },
          enabled: false,
          href: '/system/editrole',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['EditRole']),
          perm: 'EditRole',
          page: <EditRole />,
          hideSidebar: true,
        },
        {
          name: 'View Role',
          icon: () => {
            return <img src={manageRolesIcon} style={{ width: 30 }} />;
          },
          enabled: false,
          href: '/system/viewrole',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewRoles']),
          perm: 'ViewRoles',
          page: <ViewRole />,
          hideSidebar: true,
        },
        {
          name: 'Users',
          icon: () => {
            return <img src={usersIcon} style={{ width: 40 }} />;
          },
          enabled: false,
          href: '/system/createuser',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['FusionSignUpEnabled']),
          perm: 'FusionSignUpEnabled',
          page: <UserManager />,
        },
        {
          name: 'Edit User',
          icon: () => {
            return <img src={usersIcon} style={{ width: 40 }} />;
          },
          enabled: false,
          href: '/system/edituser',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditUsers']),
          perm: 'Create-EditUsers',
          page: <EditUser />,
          hideSidebar: true,
        },
        {
          name: 'View User',
          icon: () => {
            return <img src={usersIcon} style={{ width: 40 }} />;
          },
          enabled: false,
          href: '/system/viewuser',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewUsers']),
          perm: 'ViewUsers',
          page: <ViewUser />,
          hideSidebar: true,
        },
        {
          name: 'License Admin',
          icon: () => {
            return <img src={licenseIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/licenseAdmin',
          permission: () => perms.testPermission([8, 11, 12, 13]),
          href: "/system/licenseAdmin",
          permission: () => perms.testPermission([12, 13]),
          perm: null,
          page: <LicenseInformation inline />,
        },
        {
          name: 'Audit Logs',
          icon: () => {
            return <img src={auditLogIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/auditlogs',
          permission: () => perms.testPermission([8, 11, 13]),
          perm: null,
          href: "/system/auditlogs",
          permission: () => perms.testPermission([8, 10, 11, 12, 13], ["ViewAuditLog"]),
          perm: "ViewAuditLog",
          page: <AuditLogsV2 />,
        },
        {
          name: 'Help',
          icon: () => {
            return <img src={helpIcon} style={{ width: 30 }} />;
          },
          enabled: true,
          href: '/system/help',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13]),
          perm: null,
          page: <Help />,
        },
        {
          name: 'User Menu',
          icon: () => {
            return <img src={manageRolesIcon} style={{ width: 40 }} />;
          },
          enabled: false,
          href: '/usermenu',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13]),
          perm: null,
          page: <UserMenu />,
          hideSidebar: true,
        },
        {
          name: 'Page Not Found',
          enabled: false,
          icon: () => {
            return <img src={helpIcon} style={{ width: 30 }} />;
          },
          href: '/404',
          permission: () => perms.testPermission([8, 9, 10, 11, 12, 13]),
          perm: null,
          page: <Page404 />,
          hideSidebar: true,
        },
      ],
    },
  ];
}
